// Module
var code = `<div class="additional-verification-screen-main {{#if showGoogleAuthenticatorScreen}}google-authenticator{{/if}}">
    {{#if showGoogleAuthenticatorScreen}}
        <googleAuthenticator userID="{{userID}}" okCallBack="{{okCallBack}}" closeCallBack="{{@this.onCloseButtonClick}}"/>
    {{else}}
    <div class="additional-verification-screen-container">
        <terceraLabel text="{{.reasonText}}"/>
    
        <passwordTextBox text="{{.verificationValue}}" tooltip="{{.verificationValueTooltip}}" placeholder="{{.verificationValuePlaceholder}}" autofocus="true" showPasswordPreview="{{.allowPreviewPassword}}"/>
    </div>
    
    <div class="additional-verification-screen-footer">
        <terceraButton terceraButtonStyle="js-button-ok style-width-100"  text="{{.okText}}" on-btnClick="okClick" enabled="{{!!(.verificationValue)}}"/>
        {{#if !(.hideCancel)}}
            <terceraButton terceraButtonStyle="js-button-gray25 style-width-100"  text="{{.cancelText}}"   on-btnClick="cancelClick" />
        {{/if}}
    </div>
    {{/if}}
</div>
`;
// Exports
export default code;